import { useOrgContextOrNull } from "../../app/orgContext.js";
import { useRosterArtists } from "../../app/hooks/useRoster.js";
import { ProPlanBlock, ProPlanActions } from "../billing/ProPlanBlock.js";
import styles from "../settings/SettingsScreen.module.scss";

/**
 * Artist plan — the org side of ART-142: upgrade or downgrade the artist an org has in focus, from their own
 * Settings, which is where the handoff puts it ("Roster orgs can upgrade a linked artist from their
 * Settings").
 *
 * It is the SAME body and the SAME controls the band's own Settings › Account tab mounts through
 * {@link PlanDialog}. An org seat and a band seat looking at one artist are looking at one subscription, and
 * a second copy of this surface is how the two would come to disagree about what a band is paying — the
 * roster shell's own history of forked components is the argument. What differs is only PLACEMENT: the dialog
 * pins the controls in its footer, this tab stacks them under the copy.
 *
 * **The artist is NAMED** (PO, 2026-09-10), and here that matters most: this dialog is opened from the org's
 * account chip with whichever artist the rail happens to have in focus, so "this band" leaves the reader to
 * work out whose subscription they are about to change. The name comes from the roster list the shell has
 * already loaded — the same query, so it costs no request and cannot name the artist differently from the rail.
 *
 * The block re-checks both server verdicts itself, so this tab body needs no gate of its own; the TAB is
 * gated (see `orgSettingsTabs`) so a seat that would only be refused never sees it.
 */
export function OrgSettingsArtistPlanTab({ artistId }: { artistId: string }) {
  const org = useOrgContextOrNull();
  const artists = useRosterArtists(org?.orgId);
  const name = artists.data?.find((a) => a.bandId === artistId)?.name;

  return (
    <div className={styles.stack}>
      <ProPlanBlock bandId={artistId} bandName={name} />
      <ProPlanActions bandId={artistId} />
    </div>
  );
}
